module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABCElEQVQ4jZ2TTWrCUBSFvzyks+zBKjgQkhU4kg4E1xGVNymupLMg2i5D6KB0Uleg4swfugUnxYGVa240kNdU80Emeefcl3NzrxcEAVnm8b4JREAHqOnRBngHJqH1V1n9pcA83j8AL8AAMLg5Aq/Ac2j9H1KhmqeALTCn+p5o1XMRy81POXlrmzx52urB+/2qSuaF8+bWOnk9e3QVkThBRRvm/uxZvSDN2RMZ7babvyOkdEzmV5WhVtTxWzgYHZKyfBudsLJ8SIE3/SX3Ip6JCa2/BEYlCozEK3MgDIFGbhrdAyR8qicZoND6B6ALxP/EkbOxaNVz3cYUXed+Zp1FuJOG6TpL5ATgBAO2Qs5biVDwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ts_tb_fygl.png
// module id = aWT2
// module chunks = 181